import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { gql } from '@apollo/client';
import { getStudioMapInfo } from '../graphql/queries/queriesStudio';
import { getCloudFrontImageUrl } from '../util/cloudFrontUtils';
import awsConfig from '../config/aws-config';

export const useFetchMapStudio = (studioId) => {
  const GET_STUDIO_MAP_INFO = gql`${getStudioMapInfo}`;

  const { 
    data,
    loading, 
    error
  } = useQuery(GET_STUDIO_MAP_INFO, {
    variables: {
      id: studioId
    },
    skip: !studioId
  });

  const processedStudio = useMemo(() => {
    if (!data?.getStudio) return null;
    
    const studio = { ...data.getStudio };
    
    // Process studio images
    if (studio.images && Array.isArray(studio.images)) {
      studio.processedImages = studio.images.map(imageKey => {
        if (!imageKey) return '';
        
        try {
          return getCloudFrontImageUrl(imageKey, { 
            width: 800,
            height: 600, 
            fit: 'cover' 
          });
        } catch (error) {
          try {
            const cleanKey = imageKey.startsWith('public/') ? imageKey : `public/${imageKey}`;
            return `https://${awsConfig.Storage.S3.bucket}.s3.${awsConfig.Storage.S3.region}.amazonaws.com/${cleanKey}`;
          } catch (fallbackError) {
            return '';
          }
        }
      });
    } else {
      studio.processedImages = [];
      studio.images = [];
    }
    
    studio.hasImages = studio.images && studio.images.length > 0;
    
    return studio;
  }, [data]);

  return {
    studio: processedStudio,
    loading,
    error
  };
};
